module.exports = __webpack_public_path__ + "img/panoramic-contacts.df528685.jpg";